import _ from "lodash";
import mixpanel from "mixpanel-browser";
export class MixPanelAdapter {
    constructor() {}

    event(event, fields) {
        let eventName = event
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
        mixpanel.track(eventName, {
            ...this.params,
            ...fields
        });
    }

    setParamns(params) {
        this.params = params;
    }

    init(token) {
        mixpanel.init(token, { debug: false });
    }

    identify() {
        mixpanel.identify(this.user._id);

        mixpanel.people.set({
            email: _.get(this.user, "username"),
            roles: _.get(this.user, "roles"),
            accountingId: _.get(this.user, "profile.accountingId")
        });
    }

    setUser(user) {
        this.user = user;
        this.identify();
    }
}
